import { LoadState } from "../../constants/enum";
import { IReservation, IReservationState, ITableReservationTimeSlot } from "./reservations.types";


export const defaultReservation: IReservation = {
    reservation_uuid: null,
    user_name: "user one",
    user_email: "user@gmail.com",
    user_phone_no: "1234567890",

    reservation_date: new Date().toISOString(),
    reservation_from_time: "",
    reservation_to_time: "",

    number_of_people: 5,
    table_no: "",
    table_id: "",

    outlet_uuid: "",
    layout_uuid: "",
    layout_name: "",
    status: "ACTIVE"

}

export const defaultReservationState: IReservationState = {
    reservations_list: {
        loading: LoadState.idle,
        data: [],
        totalRecords: 0,
        error: null,
    },
    single_reservation: {
        loading: LoadState.idle,
        data: defaultReservation,
        error: null,
    },
    reservations_time_slot_list: {
        loading: LoadState.idle,
        data: {},
        error: null,
    },
}



export const sample_reserv_data: ITableReservationTimeSlot[] = [
    {
        time_slot: "09:00 -09:30",
        tables: [
            { table_id: "ff87976y9s8f", table_number: "1", "status": "AVAILABLE", reservation_details: [] },
            { table_id: "SFGBF&SsfFS", table_number: "2", "status": "AVAILABLE", reservation_details: [] },
            { table_id: "SFGBFFSF3SF", table_number: "3", "status": "AVAILABLE", reservation_details: [] },
        ]
    },
    {
        time_slot: "09:30 -10:00",
        tables: [
            { table_id: "ff87976y9s8f", table_number: "1", "status": "AVAILABLE", reservation_details: [] },
            { table_id: "SFGBF&SsfFS", table_number: "2", "status": "RESERVED", reservation_details: [] },
            { table_id: "SFGBFFSF3SF", table_number: "3", "status": "AVAILABLE", reservation_details: [] },
        ]
    },
    {
        time_slot: "10:00 -10:30",
        tables: [
            { table_id: "ff87976y9s8f", table_number: "1", "status": "AVAILABLE", reservation_details: [] },
            { table_id: "SFGBF&SsfFS", table_number: "2", "status": "AVAILABLE", reservation_details: [] },
            { table_id: "SFGBFFSF3SF", table_number: "3", "status": "RESERVED", reservation_details: [] },
        ]
    },
    {
        time_slot: "10:30 -11:00",
        tables: [
            { table_id: "ff87976y9s8f", table_number: "1", "status": "AVAILABLE", reservation_details: [] },
            { table_id: "SFGBF&SsfFS", table_number: "2", "status": "AVAILABLE", reservation_details: [] },
            { table_id: "SFGBFFSF3SF", table_number: "3", "status": "RESERVED", reservation_details: [] },
        ]
    },
    {
        time_slot: "11:00 -11:30",
        tables: [
            { table_id: "ff87976y9s8f", table_number: "1", "status": "RESERVED", reservation_details: [] },
            { table_id: "SFGBF&SsfFS", table_number: "2", "status": "AVAILABLE", reservation_details: [] },
            { table_id: "SFGBFFSF3SF", table_number: "3", "status": "AVAILABLE", reservation_details: [] },
        ]
    },
    {
        time_slot: "11:30 -12:00",
        tables: [
            { table_id: "ff87976y9s8f", table_number: "1", "status": "RESERVED", reservation_details: [] },
            { table_id: "SFGBF&SsfFS", table_number: "2", "status": "AVAILABLE", reservation_details: [] },
            { table_id: "SFGBFFSF3SF", table_number: "3", "status": "AVAILABLE", reservation_details: [] },
        ]
    },
    {
        time_slot: "12:00 -12:30",
        tables: [
            { table_id: "ff87976y9s8f", table_number: "1", "status": "AVAILABLE", reservation_details: [] },
            { table_id: "SFGBF&SsfFS", table_number: "2", "status": "AVAILABLE", reservation_details: [] },
            { table_id: "SFGBFFSF3SF", table_number: "3", "status": "AVAILABLE", reservation_details: [] },
        ]
    }
]